import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, checkAuth } = useAuthStore();
  const [isChecking, setIsChecking] = useState(true);

  console.log(
    "[ProtectedRoute] Initial render - isAuthenticated:",
    isAuthenticated
  );

  useEffect(() => {
    console.log("[ProtectedRoute] useEffect running - checking authentication");
    const authResult = checkAuth();
    console.log("[ProtectedRoute] checkAuth result:", authResult);
    console.log(
      "[ProtectedRoute] isAuthenticated after checkAuth:",
      useAuthStore.getState().isAuthenticated
    );
    setIsChecking(false);
  }, []); // checkAuth doesn't need to be in dependencies

  if (isChecking) {
    console.log("[ProtectedRoute] Still checking authentication...");
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-lg">Loading...</p>
      </div>
    );
  }

  // Avoid false logout on refresh: if a token exists in localStorage, allow rendering
  const hasLocalToken = typeof window !== 'undefined' && !!localStorage.getItem('token');
  if (!isAuthenticated && !hasLocalToken) {
    console.log("[ProtectedRoute] Not authenticated (and no local token), redirecting to login");
    return <Navigate to="/login" replace />;
  }

  console.log("[ProtectedRoute] Authentication confirmed or token present, rendering children");
  return <>{children}</>;
}
